import { raw } from "../render";
import { escapeHtml } from "./escape-html";
import { toKebabName } from "./string";
const validAttributeName = /^[^\s"'>/=]+$/;
const validCustomPropertyName = /^--[a-zA-Z0-9_-]+$/;
const ariaNameAliases = {
    describedBy: "describedby",
    labelledBy: "labelledby",
};
function warnInvalidName(type, name) {
    console.warn(`[lp] Ignoring invalid ${type} name "${name}".`);
}
function isPresentAttrValue(value) {
    return value !== null && value !== undefined && value !== false && value !== "";
}
function isValidAttributeName(name) {
    return validAttributeName.test(name);
}
function normalizeAriaName(name) {
    const rawName = name.startsWith("aria-") ? name.slice(5) : name;
    const mappedName = ariaNameAliases[rawName] || rawName;
    return `aria-${toKebabName(mappedName)}`;
}
function normalizeDataName(name) {
    const rawName = name.startsWith("data-") ? name.slice(5) : name;
    return `data-${toKebabName(rawName)}`;
}
export function attr(name, value) {
    if (!isPresentAttrValue(value)) {
        return raw("");
    }
    if (!isValidAttributeName(name)) {
        warnInvalidName("attribute", name);
        return raw("");
    }
    if (value === true) {
        return raw(` ${name}`);
    }
    return raw(` ${name}="${escapeHtml(String(value))}"`);
}
export function spreadAttrs(attributes, options = {}) {
    if (!attributes) {
        return raw("");
    }
    const omit = Array.isArray(options) ? options : options.omit || [];
    return raw(Object.entries(attributes)
        .filter(([name]) => !omit.includes(name))
        .map(([name, value]) => attr(name, value))
        .join(""));
}
export function ariaAttrs(attributes) {
    if (!attributes) {
        return raw("");
    }
    return raw(Object.entries(attributes)
        .map(([name, value]) => attr(normalizeAriaName(name), value))
        .join(""));
}
export function dataAttrs(attributes) {
    if (!attributes) {
        return raw("");
    }
    return raw(Object.entries(attributes)
        .map(([name, value]) => attr(normalizeDataName(name), value))
        .join(""));
}
export function styleVars(variables) {
    return Object.entries(variables)
        .filter(([, value]) => value !== null && value !== undefined && value !== "")
        .map(([name, value]) => {
        if (!validCustomPropertyName.test(name)) {
            warnInvalidName("CSS custom property", name);
            return "";
        }
        return `${name}: ${String(value)};`;
    })
        .filter(Boolean)
        .join(" ");
}
export function numberToPxValue(value) {
    if (typeof value === "number") {
        return `${value}px`;
    }
    return value;
}
